import React from "react";

const PrivacyModal = ({ onClose }) => (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl p-8 text-center max-w-md">
            <h2 className="text-2xl font-bold text-white mb-4">Privacy Policy</h2>
            <p className="text-white/80 mb-6">
                We do not track or collect any personal information.
                Your privacy is our priority! 🕵️‍♀️🛡️
            </p>
            <button
                onClick={onClose}
                className="bg-white/20 text-white px-6 py-2 rounded-full hover:bg-white/30 transition-colors"
            >
                Close
            </button>
        </div>
    </div>
);

export default PrivacyModal;